import React from 'react';
import PropTypes from 'prop-types';
import colors from 'common/styles/colors';
import {
  defectsActivityFilters,
  seedActivityListFilters
} from 'home/Widget/helpers/helpers';
import OrgShareBySiteWidget from './OrgShareBySiteWidget';

const WIDGET_NAME = 'org_total_defects_by_site';

// Defects are tasks, so Activity rather than Assets.
const defectsSiteTarget = (accountId) => {
  seedActivityListFilters(accountId, defectsActivityFilters());
  return '/activity';
};

const OrgTotalDefectsBySite = props => (
  <OrgShareBySiteWidget
    {...props}
    widgetName={WIDGET_NAME}
    siteLinkTo={defectsSiteTarget}
    emptyMessageKey="orgView.defects.noData"
    emptyMessageDefault="No defect data"
    summaryLabelKey="orgView.defects.orgSummary"
    summaryLabelDefault="Total defects"
    getSummaryValue={summary => summary.total_defects}
    getSiteValue={site => site.defect_count}
    renderSummaryMeta={(t, summary) => t('orgView.defects.meta', {
      count: summary.sites_with_defects != null ? summary.sites_with_defects : 0,
      defaultValue: '{{count}} sites with defects'
    })}
    barColor={colors.warning}
    compact
    loadingHeight="80px"
  />
);

OrgTotalDefectsBySite.propTypes = {
  organisationId: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired,
  widgetsMetadata: PropTypes.object,
  title: PropTypes.string
};

OrgTotalDefectsBySite.defaultProps = {
  widgetsMetadata: null,
  title: null
};

export default OrgTotalDefectsBySite;
